<template>
  <div>
    <h5 class="mb-5" ><i class="dot"></i> 안전계획 수립 정보</h5>
    <div class="writeGridContainer">
      <div class="writeGridHalf">
        <div>수립연도</div>
        <ml-input type="number" v-model="form.year"/>
      </div>
      <div class="writeGridHalf hidden xl:block"></div>
      <div class="writeGridHalf">
        <div>시설종류</div>
        <ml-input v-model="form.type"/>
      </div>
      <div class="writeGridHalf hidden xl:block"></div>
      <div class="writeGridLineItem">
        <div>시설물명</div>
        <field-selector v-model="form.fields" multiple/>
      </div>
      <div class="writeGridHalf">
        <div>관리방법</div>
        <vs-select autocomplete v-model="form.managementMethod">
          <vs-select-item text="직접관리" value="직접관리" />
          <vs-select-item text="위탁관리" value="위탁관리" />
        </vs-select>
      </div>
      <div class="writeGridHalf">
        <div>소관부서</div>
        <ml-input v-model="form.taskDepartment"/>
      </div>
    </div>
  </div>
</template>

<script>
import FieldSelector from "@/components/selector/FieldSelector.vue";

export default {
  components: {FieldSelector},
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        if (this.value) {
          this.form.year = this.value.year;
          this.form.type = this.value.type;
          this.form.fields = this.value.fields || [];
          this.form.managementMethod = this.value.managementMethod || "직접관리";
          this.form.taskDepartment = this.value.taskDepartment;
        }
      },
    },
    form: {
      immediate: false,
      deep: true,
      handler() {
        this.$emit("input", this.form);
      },
    },
  },

  data () {
    return {
      form: {
        year: "",
        type: "",
        fields: [],
        managementMethod: "직접관리",
        taskDepartment: "",
      },
    };
  }
}
</script>

<style scoped>

</style>
